import {AbstractStandardPanel} from "@/scenes.ui/abstract-standard-panel";
import {Keys} from "@/constants/key";
import {ConsumableType, ConsumableWithCount} from "@/store/consumable/types";
import {Tr} from "@/i18n/i18n";
import TextUtils from "@/utils/text-utils";
import {Fonts} from "@/constants/font";
import {Scene} from "phaser";
import SpriteUtils from "@/utils/sprite-utils";
import AtlasUtils from "@/utils/atlas-utils";
import ConsumableDetailsPanel from "@/scenes.ui/consumable-details-panel";

export class BackpackPanel extends AbstractStandardPanel {

    private readonly DEPTH: number = 3000;

    public static HEIGHT_CELLS = 6;
    public static WIDTH_CELLS = 8;

    constructor(scene: Scene, canvas: HTMLCanvasElement, cs: ConsumableWithCount[], slotsCallback: () => unknown) {
        super(scene, canvas, '');
        this.setDepth(this.DEPTH);

        let self = this;
        this.title = TextUtils.addTextByFamily(this.scene, Tr('backpack'), 0, this.getTitleY(), '#d3b15a', 21,
            'normal', 420, Fonts.ARIAL_MT)
            .setOrigin(0.5, 0.5);
        this.add(this.title)

        let info = TextUtils.addTextByFamily(scene,  Tr('backpack.info') , -65, -175,
            '#b3b3b3', 15, 'normal', 400, Fonts.MYRIADPRO_REGULAR);

        let slotsText = TextUtils.addTextByFamily(scene, Tr('cust.slots').toLowerCase(), 197, -151,
            '#58b6be', 14, 'normal', 110, Fonts.MYRIADPRO_REGULAR);
        slotsText.setLineSpacing(-7);

        let slotsButton = SpriteUtils.addSprite(scene, 197, -188,
            Keys.UI_BACKPACK_SLOTS_ICON, undefined, 1.2, 1.2);

        slotsButton.setInteractive().on('pointerup', function() {
            slotsCallback();
        });
        slotsText.setInteractive().on('pointerup', function() {
            slotsCallback();
        });

        let dx = 66;
        let dy = 66;
        let x0 = - BackpackPanel.WIDTH_CELLS / 2 * dx + 32;
        let y0 = -90;
        let i = 0;
        cs.forEach(cc => {

            let row = Math.floor(i / BackpackPanel.WIDTH_CELLS);
            let column = i % BackpackPanel.WIDTH_CELLS;

            let atlas = AtlasUtils.getConsumableNoShadeAtlas(cc.imageId) || cc.imageId;
            let image = atlas != cc.imageId? cc.imageId : undefined;

            let slotButton = SpriteUtils.addSprite(scene, x0 + column*dx, y0 + row*dy,
                atlas, image,1.2, 1.2);
            this.add(slotButton)

            let slotShadow = SpriteUtils.addSprite(scene, x0 + column*dx +27, y0 + row*dy + 32,
                Keys.UI_BACKPACK_CORNER_SHADOW, undefined,0.8, 0.8);
            slotShadow.setOrigin(1,1)
            this.add(slotShadow);

            let slotNumber = TextUtils.addTextAdvanced(scene,  "" + cc.count, x0 + column*dx +27, y0 + row*dy + 32,
                '#ffffff', 14, 'normal', 110, 'left', 2, Fonts.MYRIADPRO_REGULAR);
            slotNumber.setOrigin(1, 1);
            this.add(slotNumber);

            let mirrorInfo = column >= 6;

            slotButton.setInteractive().on('pointerup', function() {
                self.add(new ConsumableDetailsPanel(scene, x0 + column*dx, y0 + row*dy, canvas, cc, mirrorInfo))
            })
            i++;
        })

        this.add([info, slotsText, slotsButton])
    }

    protected onClose(): void {

    }

    protected getWindowKey(): string {
        return Keys.UI_BACKPACK_WINDOW;
    }

    protected getXButtonY(): number {
        return -266;
    }

    protected getXButtonX(): number {
        return 266;
    }

    protected getTitleY(): number {
        return -242;
    }

    protected getCloseButtonX(): number {
        return 0;
    }

    protected getCloseButtonY(): number {
        return 105;
    }

}
